import env from '@beam-australia/react-env';

const fairVersion = () => env('FAIR_VERSION');

const initialState = {
  terms: false,
  privacy: false,
  about: false,
  version: fairVersion(),
};

export default initialState;
